module.exports = __webpack_public_path__ + "static/img/logo.15bfbdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/logo.png
// module id = 9HEr
// module chunks = 1